export const SAMPLE_STATES = {
  NEW: 'NEW',
  RUNNING: 'RUN',
  READY: 'REA',
} as const;
